"use strict";

module.exports = {
    trackingPath: '//dev-api.agentshield.com/t/1x1clear.gif',
    server: '//dev-app.agentshield.com',
    restPath: '//dev-toolbox.agentshield.com/agent-shield-1.0/rest',
    widgetHost: 'https://dev-widgets.agentshield.com',
    toolboxHost: '//dev-toolbox.agentshield.com',
    intercomAppId: 'ijh052u7',
    intercomAppIdAgent: 'ijh052u7'
};
